import { isOldIE } from './platform-detector';

if (isOldIE()) {
  // Extend file reader functionality for IE
  if (FileReader.prototype.readAsBinaryString === undefined) {
    FileReader.prototype.readAsBinaryString = function (fileData) {
      var binary = '';
      var pt: FileReader & { content?: any } = this;
      var reader = new FileReader();
      reader.onload = function (_) {
        var bytes = new Uint8Array(reader.result as ArrayBufferLike);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        pt.content = binary;
        (pt as any).onload(null);
      };
      reader.readAsArrayBuffer(fileData);
    };
  }
}
